/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count, convert, clean up and transform text.`)
};

const es_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta, convierte, limpia y transforma texto.`)
};

const de_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text zählen, konvertieren, bereinigen und umwandeln.`)
};

const nl_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel, converteer, ruim op en transformeer tekst.`)
};

const fr_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez, convertissez, nettoyez et transformez du texte.`)
};

const it_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta, converti, ripulisci e trasforma il testo.`)
};

const pt_br2_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte, converta, limpe e transforme textos.`)
};

const pt_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte, converta, limpe e transforme texto.`)
};

const ja_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストのカウント、変換、整形、加工。`)
};

const zh_cat_text_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计、转换、清理和转换文本。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_text_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_text_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_text_desc", locale)
	if (locale === "en") return en_cat_text_desc(inputs)
	if (locale === "es") return es_cat_text_desc(inputs)
	if (locale === "de") return de_cat_text_desc(inputs)
	if (locale === "nl") return nl_cat_text_desc(inputs)
	if (locale === "fr") return fr_cat_text_desc(inputs)
	if (locale === "it") return it_cat_text_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_text_desc(inputs)
	if (locale === "pt") return pt_cat_text_desc(inputs)
	if (locale === "ja") return ja_cat_text_desc(inputs)
	return zh_cat_text_desc(inputs)
};